// GENERAL
import React, { useEffect, useState } from "react";

// COMPONENTS
import {
	PrimaryTable,
	Section,
	BaseText,
	BaseButton,
	PrimaryButton,
} from "../../components";
import { CreateItemModal } from "./view/index";

// HOOKS
import { DataTableContextProvider } from "../../components/ui/Tables/hooks/useDataTableContext";
import { PageDataProvider } from "../../hooks/usePageDataContext";
import usePageListDetails from "../../hooks/usePageListDetails";
import { useHostName, usePrivilegeCheck } from "../../hooks";

// TYPES
import { TableDisplayData } from "../../components/ui/Tables/types";

// UTILS
import { getFontAwesomeIcon } from "../../utils";

const ItemsPage: React.FC = () => {
	const hostName = useHostName();
	const { isAdmin } = usePrivilegeCheck();
	const [isAdditionalDataLoaded, setIsAdditionalDataLoaded] = useState(false);
	const [pageTitle, setPageTitle] = useState<string>("Items");
	const [hasModalTable, setHasModalTable] = useState<boolean>(true);

	const [data, setData] = useState<any[]>([]);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const slug = "items";
	const { pageMeta } = usePageListDetails("items-listing");
	const [tableDisplayData, setTableDisplayData] = useState<TableDisplayData>({
		hasInfiniteScroll: false,
		leftLockedColumns: -1,
		isNestedTable: false,
		hasNestedTable: false,
		suffixColumnIndexes: [-1],
		tableSlug: "items",
		tableType: "primary",
		leftOffset: 219,
		hasCellExpansion: [],
	} as TableDisplayData);

	//Building Additional Data object
	const additionalData = {
		slug: "catalogId",
		uuid: "1",
		isQuote: true,
	};

	const handleListingModalClick = () => {
		setIsOpen((prevState) => !prevState);
	};

	useEffect(() => {
		setIsAdditionalDataLoaded(true);
	}, [hostName.hostName, isAdmin]);

	const baseButtonClassNames =
		"text-sm bg-primary text-white px-4 flex items-center gap-2 hover:bg-primaryDefaultHover border-none font-omnes-medium";
	const containerClassNames = "pt-10 mx-[60px] h-full  font-omnes-regular";
	const sectionClassNames = "flex justify-between py-6";

	const modal = (
		<CreateItemModal
			isOpen={isOpen}
			handleListingModalClick={handleListingModalClick}
		/>
	);

	return (
		<div className={containerClassNames}>
			<Section additionalClasses={sectionClassNames}>
				<div className="flex items-center">
					{getFontAwesomeIcon("box", "solid")}
					<BaseText
						text={pageTitle}
						additionalClasses="pl-2"
						size="text-[22px]"
						color="text-navy-500"
						tag="h1"
						fontFamily="font-omnes-medium"
					/>
				</div>
				<PrimaryButton
					icon={getFontAwesomeIcon("plus", "solid")}
					iconClasses="text-sm"
					text="New Item"
					onClick={handleListingModalClick}
					additionalClasses={baseButtonClassNames}
				/>
			</Section>
			{isAdditionalDataLoaded && (
				<PageDataProvider pageMeta={pageMeta} pageTitle={pageTitle}>
					<DataTableContextProvider
						showStickyColumn
						hasModalTable={false}
						rowsHaveModalOnClick={true}
						data={data}
					>
						<PrimaryTable
							pageTitle={pageTitle}
							hasModalTable={hasModalTable}
							setPageTitle={setPageTitle}
							setHasModalTable={setHasModalTable}
							slug={slug}
							setData={setData}
							additionalData={additionalData}
							tableDisplayData={tableDisplayData}
						/>
					</DataTableContextProvider>
				</PageDataProvider>
			)}
			{modal}
		</div>
	);
};

export default ItemsPage;
